import { render } from "./advanced-analysis.vue?vue&type=template&id=2197f5cc"
import script from "./advanced-analysis.vue?vue&type=script&lang=js"
export * from "./advanced-analysis.vue?vue&type=script&lang=js"

import "./advanced-analysis.vue?vue&type=style&index=0&id=2197f5cc&lang=scss"

import exportComponent from "C:\\Users\\Usuario\\Documents\\Git-Repositorios\\edge_frontend\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__